// extracted by mini-css-extract-plugin
export default {"main":"main_main__08dFm","logo":"main_logo__Ut2ZE","userInfo":"main_userInfo__NYu7t"};